
// @ngInject
Filters.TitleCaseFilter  = function TitleCaseFilter() {
    return function(s) {
        s = ( s === undefined || s === null ) ? '' : s;
        let arrayOfMatchedStrings = s.toString().toLowerCase().match(/([\w'áéíóúñçü])[\w'áéíóúñçü]+/ig);
        return (arrayOfMatchedStrings || []).map(match => match.substring(0, 1).toUpperCase() + match.substring(1).toLowerCase()).join(' ');
    };
};